import Server from "@/services/Server.js";

export const state = {
  applicationsList: [],
  application: {},
  applicationCountsList: [],
  applicationPeopleList: [],
  applicationImagesList: [],
  applicationHistory: []
};

export const mutations = {
  APPLICATIONS_SET(state, applications) {
    state.applicationsList = applications;
  },
  APPLICATION_SET(state, application) {
    state.application = application;
  },
  APPLICATION_COUNTS_SET(state, applicationCounts) {
    state.applicationCountsList = applicationCounts;
  },
  APPLICATION_PEOPLE_SET(state, applicationPeople) {
    state.applicationPeopleList = applicationPeople;
  },
  APPLICATION_IMAGES_SET(state, applicationImages) {
    state.applicationImagesList = applicationImages;
  },
  APPLICATION_HISTORY_SET(state, applicationHistory) {
    state.applicationHistory = applicationHistory;
  }
};

export const actions = {
  applicationsGet({ commit, dispatch }, filters) {
    return Server.applicationsQuery(filters)
      .then(response => {
        commit("APPLICATIONS_SET", response.data);
        return response.data;
      })
      .catch(error => {
        const notification = {
          error,
          type: "error",
          message: "There was a problem reading applications: " + error.message
        };
        dispatch("notificationsAdd", notification, { root: true });
        throw error;
      });
  },
  applicationsSearch({ commit, dispatch }, params) {
    return Server.applicationsQuery(params)
      .then(response => {
        commit("APPLICATIONS_SET", response.data);
        return response.data;
      })
      .catch(error => {
        const notification = {
          error,
          type: "error",
          message: "There was a problem searching applications: " + error.message
        };
        dispatch("notificationsAdd", notification, { root: true });
        throw error;
      });
  },
  applicationsClear({ commit }) {
    commit("APPLICATIONS_SET", []);
  },
  applicationsGetOne({ commit, dispatch }, id) {
    return Server.applicationsGetOne(id)
      .then(response => {
        commit("APPLICATION_SET", response.data);
        return response.data;
      })
      .catch(error => {
        const notification = {
          error,
          type: "error",
          message: "There was a problem reading application: " + id + " " + error.message
        };
        dispatch("notificationsAdd", notification, { root: true });
        throw error;
      });
  },
  applicationsUpdate({ commit, dispatch }, app) {
    return Server.applicationsUpdate(app)
      .then(response => {
        commit("APPLICATION_SET", response.data);
        const notification = {
          type: "success",
          message: "Your application has been updated"
        };
        dispatch("notificationsAdd", notification, { root: true });
        return response.data;
      })
      .catch(error => {
        const notification = {
          error,
          type: "error",
          message: "There was a problem updating your application: " + error.message
        };
        dispatch("notificationsAdd", notification, { root: true });
        throw error;
      });
  },
  applicationCountsGet({ commit, dispatch }, filters) {
    return Server.applicationsCounts(filters)
      .then(response => {
        commit("APPLICATION_COUNTS_SET", response.data);
        return response.data;
      })
      .catch(error => {
        const notification = {
          error,
          type: "error",
          message: "There was a problem reading application counts: " + error.message
        };
        dispatch("notificationsAdd", notification, { root: true });
        throw error;
      });
  },
  applicationPeopleGet({ commit, dispatch }, id) {
    return Server.applicationsPeople(id)
      .then(response => {
        commit("APPLICATION_PEOPLE_SET", response.data);
        return response.data;
      })
      .catch(error => {
        const notification = {
          error,
          type: "error",
          message: "There was a problem reading application people: " + error.message
        };
        dispatch("notificationsAdd", notification, { root: true });
        throw error;
      });
  },
  applicationImagesGet({ commit, dispatch }, id) {
    return Server.applicationsImages(id)
      .then(response => {
        commit("APPLICATION_IMAGES_SET", response.data);
        return response.data;
      })
      .catch(error => {
        const notification = {
          error,
          type: "error",
          message: "There was a problem reading application images: " + error.message
        };
        dispatch("notificationsAdd", notification, { root: true });
        throw error;
      });
  },
  applicationImagesUpdate({ commit, dispatch }, { id, images }) {
    return Server.applicationsImagesUpdate(id, images)
      .then(response => {
        commit("APPLICATION_IMAGES_SET", response.data);
        return response.data;
      })
      .catch(error => {
        const notification = {
          error,
          type: "error",
          message: "There was a problem updating application images: " + error.message
        };
        dispatch("notificationsAdd", notification, { root: true });
        throw error;
      });
  },
  applicationHistoryGet({ commit, dispatch }, id) {
    return Server.applicationsHistory(id)
      .then(response => {
        commit("APPLICATION_HISTORY_SET", response.data);
        return response.data;
      })
      .catch(error => {
        const notification = {
          error,
          type: "error",
          message: "There was a problem reading application history: " + error.message
        };
        dispatch("notificationsAdd", notification, { root: true });
        throw error;
      });
  }
};
